import Constants from './../constants/Constants';

export default class GameSequenceHandler {

    constructor(gameCtx) {
        this.gameCtx = gameCtx;
        this.currentTurnEntityIndex = Constants.FIRST_ENTITY_TURN;
        this.sequence = Constants.PLAYERS_SEQUENCE;

        if (typeof this.gameCtx.entitiesRepo == "undefined") {
            console.error("Err - this.gameCtx.entitiesRepo is not defined");
            return;
        }

        this.entitiesRepo = this.gameCtx.entitiesRepo;
        this.currentTurnIndex = this.sequence.findIndex(v => v === Constants.FIRST_ENTITY_TURN);
    }

    setNextTurn = () => {
        this.currentTurnIndex = (this.currentTurnIndex + 1) % Constants.TOTAL_PLAYERS;
    }

    getCurrentEntity = () => {
        let entity = this.entitiesRepo.getEntityByIndex(this.sequence[this.currentTurnIndex]);
        return entity;
    }

    getNextTurnEntity = () => {
        let i = this.currentTurnIndex + 1 in this.sequence ? this.currentTurnIndex + 1 : 0;
        return this.entitiesRepo.getEntityByIndex(this.sequence[i]);
    }

    getPrevTurnEntity = () => {
        let i = this.currentTurnIndex - 1 in this.sequence ? this.currentTurnIndex - 1 : this.sequence.length - 1;
        return this.entitiesRepo.getEntityByIndex(this.sequence[i])
    }

    getPlayersSequence = () => {
        return this.sequence;
    }

    getNextEntityIndexByIndex = (entityIndex) => {
        let i = this.sequence.indexOf(entityIndex);

        if (i + 1 in this.sequence) {
            return this.sequence[i + 1];
        }
        else {
            return this.sequence[0];
        }
    }

    getAllCurrentEntityEnemies = () => {
        let entities = [];
        this.sequence.forEach((entityIndex, key) => {

            if (key === this.currentTurnIndex) return;

            entities.push(this.entitiesRepo.getEntityByIndex(entityIndex));
        });

        return entities;
    }

    getEnemiesOfEntityWithoutCurrentPlayer = (entity) => {
        let entities = [];
        this.sequence.forEach((entityIndex, key) => {

            if (key === this.currentTurnIndex || key === entity.entityIndex) return;

            entities.push(this.entitiesRepo.getEntityByIndex(entityIndex));
        });
        return entities;
    }
}